'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');let

IfFmTypeDirective=class IfFmTypeDirective extends BaseControllerBackedDirective{
get restrict(){
return'A';
}

get template(){
return'<ng-transclude ng-if="::controller.isVisible" />';
}

get controller(){
return IfFmTypeDirectiveController;
}

factory(){
let directive=super.factory();
directive.transclude=!0;
return directive;
}};let










IfFmTypeDirectiveController=class IfFmTypeDirectiveController{
static get $inject(){
return['$attrs','userService'];
}

constructor($attrs,userService){
const userFMType=userService.currentUser.fatigueMeterType.asValidType;

const attrValue=$attrs.pulsarIfFmType;

const invertMatch=attrValue.startsWith('!');

let value=invertMatch?attrValue.slice(1):attrValue;
let isExplicit=value.endsWith('!');

if(isExplicit){
if(invertMatch){
throw new Error('Cannot have explicit (trailing "!") and invert-match specified at same time (prefix "!")');
}

value=value.slice(0,-1);
}

const desiredType=FatigueMeterType[value];
if(!_.exists(desiredType)){
throw new Error(`Invalid FatigueMeterType, got: "${attrValue}"`);
}

const isMatch=userFMType===desiredType||
!isExplicit&&desiredType===FatigueMeterType.Workforce&&userFMType===FatigueMeterType.WorkforceAviation;

this.isVisible=invertMatch?!isMatch:isMatch;
}};


module.exports=IfFmTypeDirective;
//# sourceMappingURL=ifFmTypeDirective.js.map
